import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import userIdReducer, {
  userIdListenerMiddleware,
} from '../features/user_id/user_id_slice';
import recipesReducer from '../features/recipes/recipes_slice';
import endUserOnboardingReducer from '../features/end_user_onboarding/end_user_onboarding_slice';
import endUserCollectionsReducer from '../features/end_user_collections/end_user_collections_slice';
import endUserPlannerReducer from '../features/end_user_planner/end_user_planner_slice';
import endUserShoppingReducer from '../features/end_user_shopping/end_user_shopping_slice';
import endUserChatReducer from '../features/end_user_chat/end_user_chat_slice';
import aiGenerationReducer from '../features/ai_generation/ai_generation_slice';
import globalSnackbarReducer from '../features/global_snackbar/global_snackbar_slice';
import loaderReducer from '../features/loader/loader_slice';
import iapReducer from '../features/iap/iap_slice';
import serverStatusReducer from '../features/server_status/server_status_slice';
import smorgStudioProgrammesReducer from '../features/smorg_studio_programmes/smorg_studio_programmes_slice';
import smorgStudioRecipesReducer from '../features/smorg_studio_recipes/smorg_studio_recipes_slice';
import smorgStudioMembershipsReducer from '../features/smorg_studio_memberships/smorg_studio_memberships_slice';
import staleResourceDetectionReducer from '../features/stale_resource_detection/stale_resource_detection_slice';
import whiteLabelReducer from '../features/white_label/white_label_slice';
import { appSyncGraphQLApi } from './smorgAppSyncGraphQLApi';

export const smorgStore = configureStore({
  reducer: {
    [appSyncGraphQLApi.reducerPath]: appSyncGraphQLApi.reducer,
    userId: userIdReducer,
    recipes: recipesReducer,
    endUserOnboarding: endUserOnboardingReducer,
    endUserCollections: endUserCollectionsReducer,
    endUserPlanner: endUserPlannerReducer,
    endUserShopping: endUserShoppingReducer,
    endUserChat: endUserChatReducer,
    aiGeneration: aiGenerationReducer,
    globalSnackbar: globalSnackbarReducer,
    loader: loaderReducer,
    iap: iapReducer,
    serverStatus: serverStatusReducer,
    smorgStudioProgrammes: smorgStudioProgrammesReducer,
    smorgStudioRecipes: smorgStudioRecipesReducer,
    smorgStudioMemberships: smorgStudioMembershipsReducer,
    staleResourceDetection: staleResourceDetectionReducer,
    whiteLabel: whiteLabelReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(appSyncGraphQLApi.middleware)
      .concat(userIdListenerMiddleware.middleware),
});

export type SmorgDispatch = typeof smorgStore.dispatch;
export type SmorgRootState = ReturnType<typeof smorgStore.getState>;
export type SmorgThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  SmorgRootState,
  unknown,
  Action<string>
>;
